import { render, staticRenderFns } from "./AeqDocumentPage.vue?vue&type=template&id=671d50e8&"
import script from "./AeqDocumentPage.vue?vue&type=script&lang=js&"
export * from "./AeqDocumentPage.vue?vue&type=script&lang=js&"
import style0 from "./AeqDocumentPage.vue?vue&type=style&index=0&id=671d50e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports